import React from "react";
import "./Healthcare.css";
import Navbar from "../components/Navbar";

const Healthcare = () => {
  return (
    <>
      <Navbar />
      <div className="industry1-container">
        <div className="industry1-content">
          <p className="para">Industries / Healthcare & Life Sciences</p>
          <h2>Healthcare & Life Sciences</h2>
          <p className="subtitle12">
            Advancing Medical Training, Patient Care, and Health Research Through Immersive XR
          </p>
          <p>
            At Spatial Computing Technologies (SpatialCT), we blend Virtual Reality (VR), Augmented
            Reality (AR), and Spatial Computing to address critical gaps in healthcare education, surgical
            planning, patient engagement, and clinical research. Our solutions enable lifelike simulations,
            immersive visualization, and remote collaboration, improving both clinical outcomes and
            training effectiveness.
          </p>
         

          {/* Healthcare Solutions */}
          <div className="industry1-grid">
            <div className="industry1-row">
              <div className="industry1-box">
                <h4>Immersive Medical Training & Simulation</h4>
                <p>Develop high-fidelity VR environments for clinical skill training, emergency response, and surgical rehearsal.</p>
                <ul>
                  <li>Realistic anatomy and patient case simulations</li>
                  <li>Dynamic scenarios: trauma care, emergency room triage, diagnostics</li>
                  <li>Interactive feedback and performance tracking</li>
                </ul>
                <p><strong>Ideal for:</strong> Medical colleges, nursing schools, hospitals</p>
              </div>

              <div className="industry1-box">
                <h4>Anatomical Visualization & Virtual Dissection</h4>
                <p>Create 3D anatomical models that can be explored using XR for teaching or planning complex surgeries.</p>
                <ul>
                  <li>Layer-by-layer dissection and cross-sectional views</li>
                  <li>Voice-guided tours for medical students and residents</li>
                  <li>Integration with DICOM scans for customized visualization</li>
                </ul>
                <p><strong>Ideal for:</strong> Medical educators, anatomy departments</p>
              </div>
            </div>

            <div className="industry1-row">
              <div className="industry1-box">
                <h4>AR-Guided Surgery & Preoperative Planning</h4>
                <p>Overlay critical anatomical data, CT/MRI scans, and procedural steps during surgery for enhanced precision.</p>
                <ul>
                  <li>AR-based intraoperative assistance via headsets or tablets</li>
                  <li>Collaborative pre-op reviews in 3D</li>
                  <li>AI-assisted surgical path planning</li>
                </ul>
                <p><strong>Ideal for:</strong> Surgeons, surgical planning teams, radiologists</p>
              </div>

              <div className="industry1-box">
                <h4>Mental Health Therapy & Exposure Treatment in VR</h4>
                <p>Deliver immersive therapy environments for cognitive behavioral therapy, phobia exposure, and PTSD treatment.</p>
                <ul>
                  <li>Safe, controlled VR environments for gradual exposure</li>
                  <li>Real-time biofeedback and mood tracking</li>
                  <li>Therapist-assisted virtual sessions</li>
                </ul>
                <p><strong>Ideal for:</strong> Psychiatrists, clinical psychologists, rehab centers</p>
              </div>
            </div>

            <div className="industry1-row">
              <div className="industry1-box">
                <h4>Patient Education & Engagement</h4>
                <p>Empower patients to understand diagnoses, procedures, and recovery journeys through interactive XR experiences.</p>
                <ul>
                  <li>Virtual walkthroughs of procedures (e.g., knee replacement)</li>
                  <li>Pre/post-op care visualizations to reduce anxiety</li>
                  <li>Pediatric-friendly environments to improve cooperation</li>
                </ul>
                <p><strong>Ideal for:</strong> Hospitals, wellness centers, pediatric units</p>
              </div>

              <div className="industry1-box">
                <h4>Collaborative Research & Life Sciences Visualization</h4>
                <p>Visualize molecular structures, protein interactions, or drug delivery simulations in immersive 3D.</p>
                <ul>
                  <li>XR interfaces for biological pathway simulations</li>
                  <li>Shared virtual labs for collaborative research</li>
                  <li>Integrate real-world data into 3D environments</li>
                </ul>
                <p><strong>Ideal for:</strong> Life sciences researchers, pharma R&D, biotech labs</p>
              </div>
            </div>
          </div>
    
          {/* Healthcare Use Cases Table */}
          <div className="usecases-section">
            <h3>Use Cases At a Glance</h3>
            <div className="table-wrapper">
              <div className="usecases-table">
                <div className="usecases-row usecases-header">
                  <div>Use Case</div>
                  <div>Target Users</div>
                  <div>Solution Type</div>
                  <div>Benefits</div>
                </div>
                <div className="usecases-row">
                 <div>Training Anatomy Education</div>
                 <div>Medical Colleges</div>
                 <div>3D XR Visualization</div>
                 <div>Hands-on learning, reusable content</div>
                </div>
                <div className="usecases-row">
                  <div>AR-Guided Surgery</div>
                  <div>Surgeons</div>
                  <div>AR Assistance</div>
                  <div>Higher precision, fewer errors</div>
                </div>
                <div className="usecases-row">
                  <div>VR Therapy</div>
                  <div>Mental Health Professionals</div>
                  <div>Cognitive XR</div>
                  <div>Controlled treatment, higher engagement</div>
                </div>
                <div className="usecases-row">
                  <div>VR Therapy</div>
                  <div>Mental Health Professionals</div>
                  <div>Cognitive XR</div>
                  <div>Controlled treatment, higher engagement</div>
                </div>
                <div className="usecases-row">
                  <div>Patient Education</div>
                  <div>Hospitals</div>
                  <div>AR/VR Experiences</div>
                  <div>Better understanding, lower anxiety</div>
                </div>
                <div className="usecases-row">
                  <div>Drug Research</div>
                  <div>Pharma & Biotech</div>
                  <div>Molecular XR</div>
                  <div>Spatial insight, faster discovery</div>
                </div>
              </div>
            </div>
     
            <div className="usecases-cta">
              <h4>Partner With Us to Revolutionize Healthcare </h4> 
                <p>
                Whether you're training future healthcare professionals, enhancing patient experience, or 
accelerating biotech R&D, SpatialCT helps you leverage immersive technology for tangible 
outcomes. 
              </p>
              <p><strong>Contact us</strong> today to book a demo or co-develop your next healthcare XR innovation. .</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Healthcare;
